export const environment = {
    production: false,
    version: '1.4.11',

    googleKey: 'AIzaSyDEery5dhm2b_jwc_VlgD9H4DCCeShtmyE',

    //************Production************
    apiUrl: 'https://api.pedeaqui.app',
    apiLogs: 'https://apifinanceiro.pedeaqui.app',
    webHookUrl: 'https://webhook.pedeaqui.app',
    socketUrl: 'wss://webhook.pedeaqui.app',


    //************Development*************
    // apiUrl: 'https://devapi.pedeaqui.app',
    // apiLogs: 'http://192.168.1.200:3000',
    // webHookUrl: 'https://devwebhook.pedeaqui.app',
    // socketUrl: 'wss://devwebhook.pedeaqui.app',
};  